import { t } from '@/i18n';
import { z } from 'zod';

export const graphTypeEnum = z.enum([
  'stackedVerticalBar',
  'pieChart',
  'treeMap',
]);

export const GraphTypeLabelModifier = {
  stackedVerticalBar: t('stacked-column-chart'),
  pieChart: t('pie-chart'),
  treeMap: t('tree-map-chart'),
} as const satisfies Record<z.infer<typeof graphTypeEnum>, string>;

const ReportProjectAnalysisModel = z.object({
  fiscalYear: z.number().int(),
  total: z.number().nullable(),
  analysisAxis: z
    .object({
      parent: z.string().nullish(),
      /** 分析の軸がnullの場合undefinedになる */
      id: z.string().nullish(),
      /** 分析の軸がnullの場合string、それ以外はnumberになる
       * 文世紀の軸が政策で政策が未設定の場合はnullになる
       */
      name: z.union([z.string(), z.number()]).nullish(),
      /** 分析の軸がnullの場合string、それ以外はnumberになる*/
      sortingCode: z.union([z.string(), z.number()]).nullish(),
    })
    .transform((data) => ({
      ...data,
      // idが存在しないことによる、分岐が至る所にあり把握が難しいため、idがない場合（年度検索の場合）はnameを文字列化してidに設定
      id: data.id ?? (data.name != null ? String(data.name) : undefined),
    })),
});

export const ProjectAnalysisModels = ReportProjectAnalysisModel.array();
